module.exports = __webpack_public_path__ + "img/logo-7-light.ee95dd11.png";